import React from 'react';

/**
 * Match http(s) URLs and bare www.* domains in plain text (stops before trailing sentence punctuation).
 */
const URL_REGEX =
  /\b(https?:\/\/[\w.-]+(?:\/[\w\-./?%#&=~]*)?|www\.[\w.-]+\.[a-z]{2,}(?:\/[\w\-./?%#&=~]*)?)/gi;

/**
 * Turns URLs in a string into <a> elements; returns an array of strings and React elements.
 */
export function linkifyTextToReact(text) {
  if (text == null || text === '') {
    return text;
  }
  const s = String(text);
  const matches = [...s.matchAll(URL_REGEX)];
  if (!matches.length) {
    return [s];
  }

  const out = [];
  let last = 0;
  for (const match of matches) {
    const idx = match.index ?? 0;
    if (idx > last) {
      out.push(s.slice(last, idx));
    }
    const raw = match[0];
    const href = raw.startsWith('http') ? raw : `https://${raw}`;
    out.push(
      React.createElement(
        'a',
        {
          key: `url-${idx}-${raw.slice(0, 24)}`,
          href,
          target: '_blank',
          rel: 'noopener noreferrer',
          className: 'text-blue-600 hover:text-blue-800 underline underline-offset-2 break-all',
        },
        raw
      )
    );
    last = idx + raw.length;
  }
  if (last < s.length) {
    out.push(s.slice(last));
  }
  return out;
}
